import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/LoyaltyService';
import { Config } from '~domain/entities/Config';

export class ConfigRepositoryVulcan {
  private config: Config;

  constructor() {
    this.config = diContainer.get(serviceNames.config);
  }

  public getConfigs = async () => {
    const config = {
      ecommConfig: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ...(window.site as any)?.loyaltyConfig
      }
    };

    this.config.updateConfig(config.ecommConfig);

    return config;
  };
}
